module.exports = __webpack_public_path__ + "img/gmaps_logo.3d2816d7.svg";